import { Injectable } from "@angular/core";
import { Bloc, ErrorState, ShowLoadingComponentState } from "../../../../shared/bloc/base-bloc";
import { 
    GetLatestNotificationsEvent, 
    GetUnseenNotificationsCountEvent, 
    GetUnseenNotificationsCountReadyState, 
    LatestNotificationsReadyState, 
    LoadMoreNotificationsEvent, 
    LoadMoreNotificationsSucessState, 
    MarkNotificationAsReadEvent, 
    MarkNotificationAsReadSucessState, 
    NotificationsEvent, 
    NotificationsState 
} from "./index";
import { NonDrawing } from "../../../../shared/model";
import { NotificationsRepository } from "src/app/core/data/repository/notifications-repository";
import { concatMap, takeUntil } from "rxjs";

@Injectable()
export class NotificationsBloc extends Bloc<NotificationsEvent, NotificationsState> {
    constructor(private notificationsRepository: NotificationsRepository) {
        super();
    }

    protected override onIncomingEvents(event: NotificationsEvent): void {
        if (event instanceof GetLatestNotificationsEvent) {
            this.onState$.next(new ShowLoadingComponentState());
            this.notificationsRepository
            .getLatestNotifications(event.filter)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (res) => {
                this.onState$.next(new LatestNotificationsReadyState(res))
              },
              error: (error) => {
                new ErrorState<NonDrawing>(new NonDrawing(), error);
              }
            })
          } else if (event instanceof LoadMoreNotificationsEvent) {
            this.onState$.next(new ShowLoadingComponentState());
            this.notificationsRepository
            .getLatestNotifications(event.filter)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (res) => {
                this.onState$.next(new LoadMoreNotificationsSucessState(res))
              },
              error: (error) => {
                new ErrorState<NonDrawing>(new NonDrawing(), error);
              }
            })
          } else if (event instanceof MarkNotificationAsReadEvent) {
            this.onState$.next(new ShowLoadingComponentState());
            this.notificationsRepository
            .markNotificationAsRead(event.notificationId)
            .pipe(
              concatMap(() => this.notificationsRepository.getUnseenNotificationsCount()),
              takeUntil(this.destroy$)
            )
            .subscribe({
              next: (result) => {
                this.onState$.next(new MarkNotificationAsReadSucessState(result, event.notificationId));
              },
              error: (error) => {
                new ErrorState<NonDrawing>(new NonDrawing(), error);
              }
            })
          } else if (event instanceof GetUnseenNotificationsCountEvent) {
            this.notificationsRepository
            .getUnseenNotificationsCount()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (response) => {
                this.onState$.next(new GetUnseenNotificationsCountReadyState(response));
              },
              error: (error) => {
                new ErrorState<NonDrawing>(new NonDrawing(), error);
              }
            })
          }
    }
}